import { ViewData, ViewPermission } from '@/endpoints/schemas'

export interface OpenedViewData {
	dirty: boolean
	form: ViewDataForm
	original: ViewDataForm
	parsedEditMode: boolean
	tab: ViewTab
}

export type ViewPermissionFlat = Omit<ViewPermission, 'user'> & {
	userCode?: string
	userComment?: string
	userDescription?: string
	userId?: number
	userName?: string
}

export type ViewDataForm = Omit<Partial<ViewData>, 'objectPermissions'> & {
	objectPermissions: ViewPermissionFlat[]
}

export enum ViewTab {
	Columns = 'Columns',
	Dependencies = 'Dependencies',
	Deployments = 'Deployments',
	Overview = 'Overview',
	Permissions = 'Permissions',
	Preview = 'Preview',
	Sources = 'Sources',
	Validation = 'Validation',
	Versions = 'Versions',
}
